import { render, staticRenderFns } from "./Associations.vue?vue&type=template&id=613617a1&"
import script from "./Associations.vue?vue&type=script&lang=js&"
export * from "./Associations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports